export const FullInfoText  =({text, icon, className}) => {
    return (
        <div className={`${className} flex flex-column text-3xl  w-screen h-screen justify-content-center align-content-center align-items-center`}>
            { icon && <i className={`text-2xl pi ${icon} `}/>}
            <i>{text}</i>
        </div>
    )
}